import { LANGS, LANG_LABEL, useLang } from './I18nProvider';
import { useCommonT } from './common';

/**
 * Compact ES | EN | DE language toggle (small bordered chips, the active one gold —
 * JP-CRM Area 11 §2.3). Persists the choice (via the provider) and is placed in
 * both portal sidebars and on the public login screen.
 *
 * `tone` adapts the colours: 'dark' for the navy sidebar, 'light' for light surfaces.
 */
export function LanguageSwitcher({ tone = 'dark' }: { tone?: 'dark' | 'light' }) {
  const { lang, setLang } = useLang();
  const t = useCommonT();
  const dark = tone === 'dark';

  return (
    <div className="row gap-4" role="group" aria-label={t('language')}>
      {LANGS.map((l) => {
        const active = l === lang;
        return (
          <button
            key={l}
            type="button"
            onClick={() => setLang(l)}
            aria-pressed={active}
            title={LANG_LABEL[l]}
            aria-label={LANG_LABEL[l]}
            style={{
              fontFamily: 'inherit',
              fontSize: 10.5,
              letterSpacing: '0.1em',
              fontWeight: active ? 600 : 500,
              padding: '3px 7px',
              borderRadius: 4,
              cursor: 'pointer',
              border: active
                ? '1px solid var(--gold-2)'
                : dark
                  ? '1px solid rgba(255,255,255,.14)'
                  : '1px solid var(--line)',
              background: active ? 'var(--gold-2)' : 'transparent',
              color: active ? 'var(--navy)' : dark ? 'var(--side-muted)' : 'var(--muted)',
            }}
          >
            {l.toUpperCase()}
          </button>
        );
      })}
    </div>
  );
}
